import { Box, Container } from '@mui/material';
import GradientCircularProgress from "../../progress/GradientCircularProgress.tsx";

const FullScreenLoader = () => {
    return (
        <Container sx={{ height: '95vh' }}>
            <Box
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: '100%' }}
            >
                <GradientCircularProgress />
            </Box>
        </Container>
    );
};

export default FullScreenLoader;
